// src/dialog/utils/walk-tree-outside.ts
import { contains, getDocument } from "@ariakit/core/utils/dom";
var ignoreTags = ["SCRIPT", "STYLE"];
function isValidElement(element, ignoredElements) {
  if (ignoreTags.includes(element.tagName)) return false;
  return !ignoredElements.some(enabledElement => enabledElement && contains(element, enabledElement));
}
function walkTreeOutside(elements, callback, ancestorCallback) {
  for (let element of elements) {
    if (!(element == null ? void 0 : element.isConnected)) continue;
    const hasAncestorAlready = elements.some(maybeAncestor => {
      if (!maybeAncestor) return false;
      if (maybeAncestor === element) return false;
      return maybeAncestor.contains(element);
    });
    const doc = getDocument(element);
    const originalElement = element;
    while (element.parentElement && element !== doc.body) {
      ancestorCallback == null ? void 0 : ancestorCallback(element.parentElement, originalElement);
      if (!hasAncestorAlready) {
        for (const child of element.parentElement.children) {
          if (isValidElement(child, elements)) {
            callback(child, originalElement);
          }
        }
      }
      element = element.parentElement;
    }
  }
}
export { isValidElement, walkTreeOutside };